<template>
    <div v-html="content"></div>
</template>
<script>
export default {
    props:{
        content: ''
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/competition/frame.vue